import { getCrudApi } from "./CrudApi";

export const productCrudApi = getCrudApi("products");
export const operationCrudApi = getCrudApi("operations");
